import { render, staticRenderFns } from "./BetonKorisnikIndex.vue?vue&type=template&id=0230d05e&scoped=true&"
import script from "./BetonKorisnikIndex.vue?vue&type=script&lang=js&"
export * from "./BetonKorisnikIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230d05e",
  null
  
)

export default component.exports